import DateFormat from "sap/ui/core/format/DateFormat";

const EMPTY = "—";

const auditTimestampFormatter = DateFormat.getDateTimeInstance({
	pattern: "yyyy-MM-dd hh:mm a"
});

export default {
	formatValue: (value: string) => {
		return value?.toUpperCase();
	},

	/**
	 * Format an ISO timestamp like `2026-04-29 10:15 PM`, optionally rendered
	 * in a specific IANA time zone (e.g. `Europe/Berlin`, `Asia/Kathmandu`).
	 * `timezone` of `"local"`, empty, or undefined uses the browser zone.
	 */
	formatAuditTimestamp: (value: string | null | undefined, timezone?: string | null): string => {
		if (!value) return EMPTY;
		const date = new Date(value);
		if (Number.isNaN(date.getTime())) return EMPTY;
		const useZone = timezone && timezone !== "local" ? timezone : undefined;
		// UI5's DateFormat.format accepts an optional sTimezone IANA id (>=1.99).
		const fmt = auditTimestampFormatter as unknown as { format(date: Date, timezone?: string): string };
		return fmt.format(date, useZone);
	}
};
